/**
 * 江苏华鹏成套电气股份有限公司-数据
 */
// 江苏华鹏成套电气股份有限公司
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
const hplb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hplb1.jpg";
const hplb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hplb2.jpg";
const hplb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hplb3.jpg";
const hplb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hplb4.jpg";
const hplb5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hplb5.jpg";
const hpgs1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgs1.jpg";

const hpcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpcp1.png";
const hpcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpcp2.png";
const hpcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpcp3.png";
const hpcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpcp4.png";
const hpcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpcp5.png";

const hpbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg1.png";
const hpbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg2.png";
const hpbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg3.png";
const hpbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg4.png";
const hpbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg5.png";
const hpbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg6.png";
const hpbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg7.png";
const hpbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpbg8.png";
// 工程案例
const hpgc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc1.png";
const hpgc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc2.png";
const hpgc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc3.png";
const hpgc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc4.png";
const hpgc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc5.png";
const hpgc6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc6.png";
const hpgc7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc7.png";
const hpgc8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc8.png";
const hpgc9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc9.png";
const hpgc10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpgc10.png";
const hpht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht1.png";
const hpht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht2.png";
const hpht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht3.png";
const hpht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht4.png";
const hpht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht5.png";
const hpht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht6.png";
const hpht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht7.png";
const hpht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht8.png";
const hpht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht9.png";
const hpht10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht10.png";
const hpht11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht11.png";
const hpht12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht12.png";
const hpht13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht13.png";
const hpht14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht14.png";
const hpht15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht15.png";
const hpht16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht16.png";
const hpht17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht17.png";
const hpht18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht18.png";
const hpht19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht19.png";
const hpht20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpht20.png";
export default {
    homeData: {
		herderBanner: [hplb1, hplb2, hplb3, hplb4, hplb5],
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/logo/hplogo.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: hpgs1,
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `江苏华鹏成套电气股份有限公司位于风景秀丽、四面环江的江苏省扬中市，西傍镇江、南邻常州、北望扬州，属于长江三角洲区域。扬中虽然是岛市，但是交通十分便捷，只需要30分钟就可到达沪宁高速公路，60分钟可到达南京，2.5小时可到达上海。`,
		//公司官网
		website: "www.huapeng.com",
		operatingStatus: "正常在业",
		//经营品类
		categories: `智能开关柜、高低压开关柜、高低压电容柜、控制屏（箱）、配电箱、直流屏、系列开关柜、箱式变电站、配电开关控制设备、电子元件及组件、高低压电器及成套设备、输配电及控制设备、电器配件、气动元件、仪器、仪表、照明器具、铜排、五金、冲件、塑料制品、电器配件、低压母线槽系统、共（离线）相母线、桥架、地面线槽、支吊架、开关柜壳体、配电箱壳体的设计、制造、研发、销售、安装。电力，电气工程设计、安装维护；普通货物道路运输；货物或技术进出口（国家禁止或涉及行政批准的货物和技术进出口除外）。（依法须经批准的项目，经相关部门批准后方可开展经营活动）
			一般项目：电力设施器材制造；机械电气设备制造；电器辅材制造；变压器、整流器和电感器制造；电气机械设备销售；机械设备销售；电力电子元器件销售；电力设施器材销售；电气辅材销售；塑料制品销售，制冷、空调设备销售；电线、电缆经营（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）`,
		//公司地址
		companyAddress: "镇江市扬中市新坝镇长虹北路",
		site: "镇江市扬中市新坝镇",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "10800万人民币",
		//成立日期
		establishment: "2016-3-16",
		//经营品牌
		brand: "华鹏",
		//主营产品
		mainProducts: "生产、销售防水材料、保温材料；防水防腐保温工程专业承包壹级；销售化工原料、建材、钢材、五金、汽车配件。",
		//企业名称
		headerTitle: "江苏华鹏成套电气股份有限公司",
		moreInfoName: "江苏华鹏成套电气股份有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `现款现结`,
		//工厂地址
		factoryAddress: "镇江市扬中市新坝镇长虹北路",
		//工厂人数
		factoryHeadcount: "360",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "10万平方米",
		capacity: "8亿元/年",

		//联系负责人
		person: "李国伟 ",
		//联系电话
		contactNumber: "18952972836",
		//资质证书
		qualificationList: [
			{
				name: "环境管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpzz1.jpg",
			},
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpzz2.jpg",
			},
			{
				name: "职业健康安全管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpzz3.jpg",
			},
			{
				name: "质量管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpzz4.jpg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "高新技术企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hpry1.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工控股集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb1.png",
				desc: "",
			},
			{
				name: "陕西航天通宇建筑工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb2.png",
				desc: "",
			},
			{
				name: "中铁建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb3.png",
				desc: "",
			},
			{
				name: "天津安捷物联科技股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb4.png",
				desc: "",
			},
			{
				name: "河北凯舟电力工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb5.png",
				desc: "",
			},
			{
				name: "中建新疆建工（集团）有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb6.png",
				desc: "",
			},
			{
				name: "中电建宁夏工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb7.png",
				desc: "",
			},
			{
				name: "厦门海迈科技股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb8.png",
				desc: "",
			},
			{
				name: "威海热电集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb9.png",
				desc: "",
			},
			{
				name: "上海千盛实业有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb10.png",
				desc: "",
			},
			{
				name: "云南耀洲电力工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb11.png",
				desc: "",
			},
			{
				name: "中国恩菲工程技术有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb12.png",
				desc: "",
			},
			{
				name: "中国公路工程咨询集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb13.png",
				desc: "",
			},
			{
				name: "中交二公局铁路建设有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hp/hphb14.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 1,
				num: 1,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1,
				num: 1,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "母线槽", img: hpcp1 },
			{ name: "桥架", img: hpcp2 },
			{ name: "高压开关柜", img: hpcp3 },
			{ name: "低压开关柜", img: hpcp4 },
			{ name: "配电箱", img: hpcp5 },
		],
		navList: [
			{
				name: "母线槽",
				isShow: false,
				id: 1,
				children: ["母线槽"],
			},
			{
				name: "桥架",
				isShow: false,
				id: 2,
				children: ["桥架"],
			},
			{
				name: "开关柜",
				isShow: false,
				id: 3,
				children: ["高压开关柜", "低压开关柜"],
			},
			{
				name: "配电箱",
				isShow: false,
				id: 3,
				children: ["配电箱"],
			},
		],
	},
    productDetailsData:	{
		母线槽: {
			name: "母线槽",
			img: hpcp1,
			modelNumber: [
				{
					title: "暂无",
					img: hpcp1,
				},
			],
			price: "--",
			detailImgs: [hpcp1],
			modelNumberText: "400A-6300A",
			brand: "华鹏",
			describe: `母线槽产品是为确保在各领域范围内的输配电中实现安全有效配电而研制的。载流范围从25A到6300A（符合IEC标准）。其创新的设计与借鉴相关先进产品的成果，您不仅可从高效省事的安装中体现到，而且从周到、灵活的母线槽制作系统中体会，是该行业中安装最方便的系统之一。
			母线槽在安装时使用的辅助设备较少，而且安装时也比其他母线系统、电缆和管道方便。整体成型的铝合金外壳起到一根整体接地的效果，单螺栓设计的连接器高效安全，而且馈电插接箱内提供的导线合理弯曲空间，在同行业中是最大的。
			母线槽其卓越的绝缘配置，是行业中的领头兵。除传统的四氟带绝缘（永不老化），还有自粘式聚酯薄膜绝缘以及先进的硅橡胶整体绝缘（无缝隙整体绝缘）。
		母线槽拥有灵活的馈电系统，整根系统中可灵活设计馈电插口，馈电箱可在各插口随意互换。`,
			report: [hpbg1, hpbg2],
		},

		桥架: {
			name: "桥架",
			img: hpcp2,
			modelNumber: [
				{
					title: "暂无",
					img: hpcp2,
				},
			],
			price: "--",
			detailImgs: [hpcp2],
			modelNumberText: "各种规格型号",
			brand: "华鹏",
			describe: `华鹏桥架系列拥有XQJ钢质汇线桥架、MQJ钢质铆接桥架、LQJ铝合金桥架、NHQJ（NBC）耐火不燃槽盒（防火桥架）、BHQ玻璃钢防腐阻燃桥架共计五大系列。其广泛应用于化工、轻工、冶金、电力、隧道、机械以及现代化办公场所等。使各类电线、电缆的敷设达到了标准化、系列化、通用化水平，它为工程设计、施工安装、生产自动化提供了广泛的走线空间。
			完善的销售体系，使您可方便的获得我公司的桥架产品及附件。周到的售前、售后服务网络，使您的安装和使用都十分容易。我公司的产品系列是为遵循ISO9001标准和行业标准、及满足您最终设计要求而专门设计的！
			`,
			report: [hpbg3],
		},

		高压开关柜: {
			name: "高压开关柜",
			img: hpbg3,
			modelNumber: [
				{
					title: "暂无",
					img: hpbg3,
				},
			],
			price: "--",
			detailImgs: [hpbg3],
			modelNumberText: "KYN28",
			brand: "华鹏",
			describe: ` KYN28高压开关柜，为复合式空气绝缘、铠装金属封闭开关设备。它适用于12KV及以下三相交流50Hz户内成套配电系统，用来接受和分配电能并对电路进行控制、保护及监测。其柜体分隔为四个独立的小室，即：母线室、断路器室、电缆终端室和低压室，其中三个高压室均设有向上的压力释放板，以保安全。`,
			report: [hpbg4],
		},

		低压开关柜: {
			name: "低压开关柜",
			img: hpcp4,
			modelNumber: [
				{
					title: "暂无",
					img: hpcp4,
				},
			],
			price: "--",
			detailImgs: [hpcp4],
			modelNumberText: "Mdmax ST",
			brand: "华鹏",
			describe: `MDmax ST是ABB公司
			开发研制的采用标准模件概念的低压柜型
			产品。MDmaxST 2013年开始在国内进行推广授
			权。ABB公司通过与中国最优秀的、高水准的低压开关柜生产厂-----华鹏集团江苏华鹏成套电气股份有限公司合作，使我们成为生产MDmax ST的“技术合作伙伴”，使得多用途的、通过型式试验的MDmax ST低压开关柜完完全全地来到了您的身边。柜型均主要分为固定插拔式、抽屉
			式、条插式三种结构形式。 
			`,
			report: [hpbg5, hpbg6],
		},

		配电箱: {
			name: "配电箱",
			img: hpcp5,
			modelNumber: [
				{
					title: "暂无",
					img: hpcp5,
				},
			],
			price: "--",
			detailImgs: [hpcp5],
			modelNumberText: "PZ2000",
			brand: "华鹏",
			describe: `MDmax ST是ABB公司
			开发研制的采用标准模件概念的低压柜型
			产品。MDmaxST 2013年开始在国内进行推广授
			权。ABB公司通过与中国最优秀的、高水准的低压开关柜生产厂-----华鹏集团江苏华鹏成套电气股份有限公司合作，使我们成为生产MDmax ST的“技术合作伙伴”，使得多用途的、通过型式试验的MDmax ST低压开关柜完完全全地来到了您的身边。柜型均主要分为固定插拔式、抽屉
			式、条插式三种结构形式。 
			`,
			report: [hpbg7, hpbg8],
		},
	},
    contactListData:{
		list: [
			{
				name: "李国伟",
				position: "销售经理(陕西省、甘肃省)",
				id: "1",
				phoneNum: "18952972836",
				telephone: "--",
				color: "#007DFF ",
				email: "liguowei@huapeng.com",
			},
			{
				name: "戴姚佳",
				position: "销售经理(北京市、天津市、河北省)",
				id: "2",
				phoneNum: "18012826572",
				telephone: "--",
				color: "#23B095 ",
				email: "daiyaojia@huapeng.com",
			},
			{
				name: "薛立仁",
				position: "销售经理(山西省、辽宁省)",
				id: "3",
				phoneNum: "13366881778",
				telephone: "--",
				color: "#007DFF ",
				email: "xueliren@huapeng.com",
			},
			{
				name: "陈勇",
				position: "销售经理(河南省、山东省)",
				id: "4",
				phoneNum: "13812352000",
				telephone: "--",
				color: "#23B095 ",
				email: "chenyong@huapeng.com",
			},
			{
				name: "顾伟",
				position: "销售经理(广东省、广西省)",
				id: "5",
				phoneNum: "15099910574",
				telephone: "--",
				color: "#007DFF ",
				email: "guwei@huapeng.com",
			},
			{
				name: "蔡之旺",
				position: "销售经理(四川省、云南省)",
				id: "6",
				phoneNum: "18605119808",
				telephone: "--",
				color: "#23B095 ",
				email: "caizhiwang@huapeng.com",
			},
			{
				name: "郭道明",
				position: "销售经理(湖南省、湖北省)",
				id: "7",
				phoneNum: "18952890396",
				telephone: "--",
				color: "#007DFF ",
				email: "guodaoming@huapeng.com",
			},
			{
				name: "杨珍娣",
				position: "销售经理(江苏省、浙江省、上海市)",
				id: "8",
				phoneNum: "18951279766",
				telephone: "--",
				color: "#23B095 ",
				email: "yangzhendi@huapeng.com",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "石家庄橡树湾",
				id: 1,
				price: "236.27万",
				time: "2021",
				site: "河北省石家庄市",
				type: "住宅",
				unit: "河北凯舟电力工程有限公司",
				desc: "橡树湾总占地面积19.6万方，总建筑面积47.6万方，容积率2.74，位居城市内环线旁，交通便利，配套成熟。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc1 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht1 },
					{ title: "", path: hpht2 },
				],
				product: "母线槽",
			},
			{
				name: "147厂房改造",
				id: 2,
				price: "48.59956万",
				time: "2021",
				site: "陕西省",
				type: "厂房",
				unit: "陕西航天通宇建筑工程有限公司",
				desc: "工程规模:本项目净用地面积16638.19平方米,总建筑面积约29337.26平方米",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc2 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht3 },
					{ title: "", path: hpht4 },
				],
				product: "母线槽",
			},
			{
				name: "龙灯山生产基地外网工程母排材料采购",
				id: 3,
				price: "16.2127万",
				time: "2022",
				site: "河北省",
				type: "厂房",
				unit: "河北东方石油建设工程有限公司",
				desc: "占地共11.7万平方米",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc3 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht5 },
					{ title: "", path: hpht6 },
				],
				product: "母线槽",
			},
			{
				name: "皇冠假日酒店项目母线槽采购合同",
				id: 4,
				price: "80.947164万",
				time: "2023",
				site: "河北省",
				type: "酒店",
				unit: "中美房地产股份有限公司",
				desc: "项目占地面积500余亩,3块宗地分期分批建设,总建筑面积约100万平方米,总投资额约25亿元。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc4 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht7 },
					{ title: "", path: hpht8 },
				],
				product: "母线槽",
			},
			{
				name: "理想之城南区二标段15#~29#楼及地下车库项目工程",
				id: 5,
				price: "266.895661万",
				time: "2021",
				site: "山东省",
				type: "房地产",
				unit: "中国建筑第八工程局有限公司",
				desc: "项目总占地1800亩,建筑面积约260万平米",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc5 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht9 },
					{ title: "", path: hpht10 },
				],
				product: "桥架",
			},
			{
				name: "小湖村安置区安装（一号院）项目",
				id: 6,
				price: "115.192182万",
				time: "2021",
				site: "陕西省西安市",
				type: "房地产",
				unit: "中建新疆建工（集团）有限公司",
				desc: "项目分为1号院、2号院、3号院共由23栋高层以及附属配楼组成，地下2层，建筑面积约58万平米，合同额超10亿，是西北公司8年来承建最大的房建项目，也是中原分公司第一个纯民生项目，是管南片区最大安置民生标杆工程。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc6 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht11 },
					{ title: "", path: hpht12 },
				],
				product: "桥架",
			},
			{
				name: "哈尔滨市轨道交通3号线二期工程机电项目JD-2-4标段",
				id: 7,
				price: "375.846128万",
				time: "2022",
				site: "黑龙江省哈尔滨市",
				type: "轨道交通",
				unit: "中交一公局电气化工程有限公司",
				desc: `车站：靖宇公园、公路大桥、河松街、丁香公园；
				区间：太平桥站（不含）～靖宇公园站区间、公路大桥站～河松街站区间、靖宇公园站～清真寺站（不含）半区间（小轴端）、上海街站（不含）～公路大桥站半区间（大轴端）、河松街站～河山街站（不含）半区间（小轴端）、河山街站（不含）～丁香公园站半区间（大轴端）、丁香公园站～体育公园站（不含）区间。
				  共4站7区间标段范围 ，标段内全部机电设备安装（风水电）及设备管理用房通风、综合支吊架等的安装、采购，包括但不限于供货、运输、交付、安装、开通、调试、试运行、培训、档案等工作。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc7 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht13 },
					{ title: "", path: hpht14 },
				],
				product: "低压开关柜",
			},

			{
				name: "大陆汽车厂房（三期）项目",
				id: 8,
				price: "528.31678万",
				time: "2021",
				site: "天津市",
				type: "厂房",
				unit: "天津经济技术开发区国有资产经营公司",
				desc: `大陆集团天津工厂成立于1995年，是大陆集团在中国设立的首批制造工厂之一，是大陆集团的重要生产基地。工厂坐落于天津经济技术开发区，占地面积85000平方米，现有员工约1600人，主要生产车身控制模块、座椅控制模块、多媒体收音系统、混合动力电机、变速箱控制单元等产品。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc8 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht15 },
					{ title: "", path: hpht16 },
				],
				product: "高、低压开关柜",
			},
			{
				name: "武当云谷大数据中心项目一期工程",
				id: 9,
				price: "600.6614万",
				time: "2022",
				site: "湖北省",
				type: "数据中心",
				unit: "武当云谷大数据科技有限公司",
				desc: `建设规模:武当云谷大数据中心项目位于湖北省丹江口右岸城区汉江大道以西、天柱路以北,项目总用地面积44547.98m2。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc9 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht17 },
					{ title: "", path: hpht18 },
				],
				product: "高压开关柜",
			},
			{
				name: "眼前山铁矿井下安全高效智慧矿山建设项目",
				id: 10,
				price: "249.00万",
				time: "2022",
				site: "辽宁省鞍山市",
				type: "办公楼",
				unit: "中国恩菲工程技术有限公司",
				desc: `眼前山铁矿是鞍钢旗下主要矿山，设计规模800万吨/年。为对矿山进行智慧化升级，2022年，中国恩菲承担了眼前山铁矿智慧矿山的EPC总承包工作。中国恩菲在项目执行过程中，充分考虑了眼前山铁矿现状，以“矿石流”为主线，融合“信息流”“业务流”“数据流”，搭载了包括采矿远程控制、无人驾驶电机车运输、智能通风、网络全覆盖等环节的全要素数据采集和控制的综合集成自动化系统，可实现井下无人化、装备自动化以及智能矿山融合控制。本节点的完成，标志着项目整体解决方案取得了实践的考验，具备了在行业内推广和复制的意义。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hpgc10 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hpht19 },
					{ title: "", path: hpht20 },
				],
				product: "配电箱（柜）",
			},
		],
	},
    evaluationData:{
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],

		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${7}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${7}.png`,
				subtitle: "高新技术企业",
				isShow: true,
			},
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "低压开关柜采购",
				name2: "低压开关柜采购",
				name3: "物资采购",
				date: "2022/7/8",
			},
			{
				name1: "华能余热工程项目博通站电气设备采购项目",
				name2: "华能余热工程项目博通站电气设备采购项目采购合同(标包001)",
				name3: "物资采购",
				date: "2022/1/12",
			},
			{
				name1: "中国电建山东电建公司宁夏电建缙云静脉产业园垃圾发电项目桥架采购项目",
				name2: "中国电建山东电建公司宁夏电建缙云静脉产业园垃圾发电项目桥架采购项目",
				name3: "物资采购",
				date: "2021/10/22",
			},
			{
				name1: "重庆市荣昌区黄金坡新区高中及初中学校建设工程配电箱项目",
				name2: "重庆市荣昌区黄金坡新区高中及初中学校建设工程配电箱项目",
				name3: "物资采购",
				date: "2021/10/8",
			},
			{
				name1: "380V开关柜(浙能绍兴滨海热电厂#8 锅炉技改工程项目)",
				name2: "380V开关柜(浙能绍兴滨海热电厂#8 锅炉技改工程项目)",
				name3: "物资采购",
				date: "2021/8/9",
			},
			{
				name1: "华能余热工程项目博通站电气设备采购项目",
				name2: "华能余热工程项目博通站电气设备采购项目",
				name3: "物资采购",
				date: "2021/8/2",
			},
			{
				name1: "容东片区C组团安置房及配套设施项目配电箱采购",
				name2: "容东片区C组团安置房及配套设施项目配电箱采购标段三",
				name3: "物资采购",
				date: "2020/11/10",
			},
			{
				name1: "青岛胶东国际机场山航基地（一期）变配电工程设备采购项目",
				name2: "青岛胶东国际机场山航基地（一期）变配电工程设备采购项目",
				name3: "物资采购",
				date: "2019/9/9",
			},
			{
				name1: "青岛胶东国际机场山航基地（一期）变配电工程设备采购项目 二次招标",
				name2: "青岛胶东国际机场山航基地（一期）变配电工程设备采购项目 二次招标",
				name3: "物资采购",
				date: "2019/8/20",
			},
			{
				name1: "北京学校(原中国人民大学附属中学通州学校)小学部配电箱采购",
				name2: "北京学校(原中国人民大学附属中学通州学校)小学部配电箱采购",
				name3: "物资采购",
				date: "2019/4/19",
			},
			{
				"企业名称": "江苏华鹏成套电气股份有限公司",
				"name1": "陕建一建-二公司-西安航天城第二中学项目-配电箱采购",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "西安航天城第二中学项目",
				"name3": "物资采购",
				"date": "2022年11月13日",
				"out": true
			}
		],
	},
    lawData: {
		info: [],
	},
    tipData:{
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
}